/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EventFollowState } from './EventFollowState';
import {
    EventFollowStateFromJSON,
    EventFollowStateFromJSONTyped,
    EventFollowStateToJSON,
} from './EventFollowState';

/**
 * 
 * @export
 * @interface EventFollowStateResponse
 */
export interface EventFollowStateResponse {
    /**
     * 
     * @type {EventFollowState}
     * @memberof EventFollowStateResponse
     */
    data?: EventFollowState;
}

/**
 * Check if a given object implements the EventFollowStateResponse interface.
 */
export function instanceOfEventFollowStateResponse(value: object): value is EventFollowStateResponse {
    let isInstance = true;

    return isInstance;
}

export function EventFollowStateResponseFromJSON(json: any): EventFollowStateResponse {
    return EventFollowStateResponseFromJSONTyped(json, false);
}

export function EventFollowStateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventFollowStateResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : EventFollowStateFromJSON(json['data']),
    };
}

export function EventFollowStateResponseToJSON(value?: EventFollowStateResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': EventFollowStateToJSON(value.data),
    };
}

